import { Component, OnInit, Inject, Injectable, Input } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { LayerService } from "../../../services/layers/layer.service";
import { FormService } from "../../../services/forms/form.service";
import { ReactiveFormsModule } from "@angular/forms";
import { FormBuilder, FormGroup, FormArray, FormControl } from "@angular/forms";

import { FieldFormService } from "../../../services/forms/field-form.service";
import { ModalAddfieldComponent } from "../../modal-addfield/modal-addfield.component";

@Component({
  selector: "app-admon-active",
  templateUrl: "./admon-active.component.html",
  styleUrls: ["./admon-active.component.css"]
})
export class AdmonActiveComponent implements OnInit {
  fields: any;
  formId: any;

  constructor(
    protected layerService: LayerService,
    protected formService: FormService,
    protected fieldFormService: FieldFormService,
    protected dialog: MatDialog,
    private dialogRef: MatDialogRef<AdmonActiveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formId = data.id;

    // tslint:disable-next-line: no-shadowed-variable
    this.layerService.getLayers().subscribe((data: {}) => {
      this.layers = data;
    });

    this.fieldFormService
      .getFieldForm({ formulario_id: this.formId })
      .subscribe((data: {}) => {
        this.fields = data["SDTFormularioid"];
      });
  }
  id: any;
  name: any;
  description: any;
  layer: any;
  layers: any;
  hash: any;

  public others: any[] = [
    {
      new_field: ""
    }
  ];

  removeOther(i: number) {
    this.others.splice(i, 1);
  }

  ngOnInit() {}

  public closeMe() {
    this.dialogRef.close();
  }

  addOther() {
    this.others.push({
      new_field: ""
    });
  }

  public createForm() {
    const formDetails = {
      capa_id: this.layer,
      formulario_nombre: this.name,
      formulario_descripcion: this.description,
      formulario_estado: 1
    };

    this.formService.createForm(formDetails).subscribe((data: {}) => {
      this.dialogRef.close({ data });
    });
  }

  public createFieldForm() {
    this.dialog
      .open(ModalAddfieldComponent, { data: { formId: this.formId } })
      .afterClosed()
      .subscribe(result => {
        this.fieldFormService
          .getFieldForm({ formulario_id: this.formId })
          .subscribe((data: {}) => {
            this.fields = data["SDTFormularioid"];
          });
      });
  }
}
